import {
    GET_NOTIFICATIONS_REQUEST,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILED
} from '../../actions/notification/get-notifications'

import {
    GET_USER_NOTIFICATIONS_REQUEST,
    GET_USER_NOTIFICATIONS_SUCCESS,
    GET_USER_NOTIFICATIONS_FAILED
} from '../../actions/notification/get-user-notifications'

import {
    ADD_NOTIFICATION_REQUEST,
    ADD_NOTIFICATION_SUCCESS,
    ADD_NOTIFICATION_FAILED
} from '../../actions/notification/add-notification'

import {
    UPDATE_NOTIFICATION_REQUEST,
    UPDATE_NOTIFICATION_SUCCESS,
    UPDATE_NOTIFICATION_FAILED,
    TOGGLE_NOTIFICATION_SUCCESS,
    TOGGLE_NOTIFICATION_FAILED
} from '../../actions/notification/update-notification'

import {
    GET_NOTIFICATION_CATEGORIES_REQUEST,
    GET_NOTIFICATION_CATEGORIES_SUCCESS,
    GET_NOTIFICATION_CATEGORIES_FAILED
} from '../../actions/notification/add-notification'

import {
    DELETE_NOTIFICATION_REQUEST,
    DELETE_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAILED
} from '../../actions/notification/delete-notification'

import { READ_MESSAGE_SUCCESS } from '../../actions/message/read-message'

const initialState = {
    notifications: [],
    categories: [],
    requesting: false,
    adding: false,
    editing: false,
    deleting: false,
    deleteError: null,
    error: null,
    total: 0,
    userNotifications: [],
    userNotificationsError: null,
    editNotificationError: null
}

export const notifications = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                notifications: [],
                error: null
            })
        case GET_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {
                notifications: action.payload.data.payload,
                requesting: false,
                error: null
            })
        case GET_NOTIFICATIONS_FAILED:
            return Object.assign({}, state, {
                notifications: [],
                requesting: false,
                error: action.error
            })
        case ADD_NOTIFICATION_REQUEST:
            return Object.assign({}, state, {
                adding: true,
                addNotificationError: null
            })
        case ADD_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                adding: false,
                addNotificationError: null,
                notifications: [...state.notifications, action.payload.data.payload]
            })
        case ADD_NOTIFICATION_FAILED:
            return Object.assign({}, state, {
                adding: false,
                addNotificationError: action.error
            })
        case UPDATE_NOTIFICATION_REQUEST:
            return Object.assign({}, state, {
                editing: true,
                editNotificationError: null
            })
        case UPDATE_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                editing: false,
                editNotificationError: null,
                notifications: state.notifications.map(n => n._id === action.payload.data.payload._id ? action.payload.data.payload : n)
            })
        case UPDATE_NOTIFICATION_FAILED:
            return Object.assign({}, state, {
                editing: false,
                editNotificationError: action.error
            })
        case TOGGLE_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                notifications: state.notifications.map(n => n._id === action.notificationId ? { ...n, active: action.payload.data.payload.active } : n)
            })
        case TOGGLE_NOTIFICATION_FAILED:
            return Object.assign({}, state, {
                toggleNotificationError: action.error
            })
        case DELETE_NOTIFICATION_REQUEST:
            return Object.assign({}, state, {
                deleting: true,
                deleteError: null
            })
        case DELETE_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                deleting: false,
                deleteError: null,
                notifications: state.notifications.filter((notification) => {
                    console.log(notification)
                    console.log(action)
                    return notification._id !== action.payload.data.payload._id
                })
            })
        case DELETE_NOTIFICATION_FAILED:
            return Object.assign({}, state, {
                deleting: false,
                deleteError: action.error
            })
        case GET_NOTIFICATION_CATEGORIES_REQUEST:
            return Object.assign({}, state, {
                error: null
            })
        case GET_NOTIFICATION_CATEGORIES_SUCCESS:
            return Object.assign({}, state, {
                categories: action.payload.data.payload,
                error: null,
            })
        case GET_NOTIFICATION_CATEGORIES_FAILED:
            return Object.assign({}, state, {
                categories: [],
                error: action.error
            })
        case GET_USER_NOTIFICATIONS_REQUEST:
            return Object.assign({}, state, {
                userNotificationsError: null
            })
        case GET_USER_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {
                userNotifications: action.payload.data.payload,
                userNotificationsError: null,
            })
        case GET_USER_NOTIFICATIONS_FAILED:
            return Object.assign({}, state, {
                userNotifications: [],
                userNotificationsError: action.error
            })
        case READ_MESSAGE_SUCCESS:
            return Object.assign({}, state, {
                userNotifications: state.userNotifications.filter(un =>  -1 === action.messageIds.indexOf(un.id))
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/notification/notifications.js